// extracted by mini-css-extract-plugin
export default {"content":"gpa-z","title":"hpa-z","subTitle":"ipa-z","banner":"jpa-z","productCardOverride":"kpa-z"};